export default function Card({ title, subtitle, icon: Icon, headerRight, children }) {
  return (
    <div className="bg-[#12141e] border border-[#1e2235] rounded-lg overflow-hidden">
      {/* Header */}
      {(title || subtitle || Icon || headerRight) && (
        <div className="px-6 py-4 border-b border-[#1e2235]">
          <div className="flex items-start justify-between">
            <div className="flex items-start gap-3 flex-1">
              {Icon && <Icon className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />}
              <div>
                {title && <h3 className="font-semibold text-white">{title}</h3>}
                {subtitle && <p className="text-gray-400 text-sm mt-1">{subtitle}</p>}
              </div>
            </div>
            {headerRight && <div className="flex-shrink-0 ml-4">{headerRight}</div>}
          </div>
        </div>
      )}

      {/* Content */}
      <div className="px-6 py-4">{children}</div>
    </div>
  );
}
